import { convertShippingList, getDefaultCurrency, getDefaultLanguage, getDefaultShipping } from "../utils/country";
import { convertCurrencyList } from "../utils/currency";

export class SettingConfig {
  constructor(
    locale,
    ipCountry,
    shippingCountry,
    shippingTo,
    currency,
    currencies,
    billingCountry,
  ) {
    this.locale = locale;
    this.ipCountry = ipCountry;
    this.shippingCountry = shippingCountry;
    this.shippingTo = shippingTo;
    this.currency = currency;
    this.currencies = currencies;
    this.billingCountry = billingCountry;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new SettingConfig(
        input.locale,
        input.ip_country,
        input.shipping_country,
        input.shipping_to,
        input.currency,
        input.currencies,
        input.billing_country,
      )
    }

    return new SettingConfig();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => SettingConfig.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [SettingConfig.fromApiObject(input)];
    }

    return [];
  }

  static getShippingOptions(shippingTo = [], shipping) {
    return convertShippingList(shippingTo, shipping);
  }

  static getCurrencyOptions(currencies = [], currency) {
    return convertCurrencyList(currencies, currency);
  }

  static getShipping(shippingCountry, shippingTo = []) {
    return getDefaultShipping(shippingCountry, shippingTo)
  }

  static getCurrency(currency, currencies = [], country) {
    return getDefaultCurrency(currency, currencies, country);
  }

  static getLanguage(lang, country) {
    return getDefaultLanguage(lang, country);
  }

  getShipping() {
    return getDefaultShipping(this.shippingCountry, this.shippingTo)
  }

  getCurrency(country) {
    if (!country) {
      country = this.getShipping();
    }
    return getDefaultCurrency(this.currency, this.currencies, country);
  }

  getLanguage(country) {
    if (!country) country = this.shippingCountry;
    return getDefaultLanguage(this.locale, country);
  }
}